import React, { Component } from 'react';
import { isEqual, debounce } from 'lodash';
import { validate, mergeStyles, getHost } from 'wix-rich-content-common';
import pluginLinkPreviewSchema from 'wix-rich-content-common/dist/statics/schemas/plugin-link-preview.schema.json';
import HtmlComponent from 'wix-rich-content-plugin-html/libs/HtmlComponent';

const LINK_PREVIEW_TYPE = "wix-draft-plugin-link-preview";

var styles = {"fontElementMap":"GZ8th","linkPreview":"Mr6s1","linkPreviewImage":"f-PwL","linkPreviewInfo":"RzvNE","linkPreviewTitle":"K-Ffp","ellipsis":"_5Ti0l","linkPreviewDescription":"lxRMI","linkPreviewUrl":"z0cCZ"};

var __defProp$1 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
class LinkPreviewViewer extends Component {
  constructor(props) {
    super(props);
    this.elementRef = null;
    this.getUrlForDisplay = (url) => url.replace(/^https?:\/\//, "");
    this.onLinkPreviewClick = () => {
      var _a, _b;
      return (_b = (_a = this.props.helpers) == null ? void 0 : _a.onViewerAction) == null ? void 0 : _b.call(
        _a,
        LINK_PREVIEW_TYPE,
        "Click",
        this.props.componentData.config.link.url || ""
      );
    };
    this.setRef = (ref) => this.elementRef = ref;
    const { componentData, theme } = props;
    validate(componentData, pluginLinkPreviewSchema);
    this.state = {};
    this.styles = mergeStyles({ styles, theme });
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginLinkPreviewSchema);
    }
  }
  componentDidMount() {
    var _a, _b;
    validate(this.props.componentData, pluginLinkPreviewSchema);
    this.setState({ imageHeight: (_a = this.elementRef) == null ? void 0 : _a.offsetHeight });
    if (window == null ? void 0 : window.ResizeObserver) {
      this.resizer = new ResizeObserver(
        debounce((entries) => {
          this.setState({ imageHeight: Math.round(entries[0].contentRect.height) });
        }, 60)
      );
    }
    this.elementRef && ((_b = this.resizer) == null ? void 0 : _b.observe(this.elementRef));
  }
  componentWillUnmount() {
    var _a;
    this.elementRef && ((_a = this.resizer) == null ? void 0 : _a.unobserve(this.elementRef));
  }
  render() {
    const { componentData, theme, isMobile, settings, iframeSandboxDomain } = this.props;
    const { enableEmbed = true } = settings;
    const { imageHeight } = this.state;
    const {
      title,
      description,
      thumbnail_url: thumbnailUrl,
      html,
      config: {
        link: { url }
      }
    } = componentData;
    const {
      linkPreview,
      linkPreviewUrl,
      linkPreviewInfo,
      linkPreviewTitle,
      linkPreviewImage,
      linkPreviewDescription
    } = this.styles;
    if (enableEmbed && html) {
      const htmlCompProps = {
        componentData: __spreadProps(__spreadValues$1({}, componentData), {
          srcType: "html",
          src: unescape(html),
          config: {}
        }),
        settings,
        theme,
        isMobile,
        iframeSandboxDomain
      };
      return /* @__PURE__ */ React.createElement(HtmlComponent, __spreadValues$1({}, htmlCompProps));
    } else {
      return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        /* @__PURE__ */ React.createElement(
          "figure",
          {
            className: linkPreview,
            "data-hook": "linkPreviewViewer",
            onClick: this.onLinkPreviewClick,
            ref: this.setRef
          },
          thumbnailUrl && /* @__PURE__ */ React.createElement(
            "div",
            {
              style: {
                width: isMobile ? "110px" : imageHeight,
                height: imageHeight,
                backgroundImage: `url(${thumbnailUrl})`
              },
              className: linkPreviewImage,
              alt: title
            }
          ),
          /* @__PURE__ */ React.createElement("section", { className: linkPreviewInfo }, /* @__PURE__ */ React.createElement("div", { className: linkPreviewUrl }, this.getUrlForDisplay(getHost(url) || url)), /* @__PURE__ */ React.createElement("figcaption", { className: linkPreviewTitle }, title), description && /* @__PURE__ */ React.createElement("div", { className: linkPreviewDescription }, description))
        )
      );
    }
  }
}

const typeMapper = () => ({
  [LINK_PREVIEW_TYPE]: { component: LinkPreviewViewer }
});

const DEFAULTS = {
  config: {
    alignment: "center",
    size: "content",
    link: {
      target: "_blank",
      rel: ""
    }
  }
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginLinkPreview = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: LINK_PREVIEW_TYPE,
    typeMapper
    // nodeViewRenderers,
  };
};

export { LINK_PREVIEW_TYPE, LinkPreviewViewer, typeMapper as linkPreviewTypeMapper, pluginLinkPreview };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-link-preview/dist/es/styles.viewer.min.global.css'